import { Button, FormHelperText, FormLabel, Input, makeStyles, TextField } from "@material-ui/core";
import { lightBlue, red, teal } from "@material-ui/core/colors";
import axios from "axios";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { endPoint, getFilteredUsers } from "../../albCommonModule";
import { getBrothers, getFirstBros, getLodingStatus, isMailAddress, makeUrlSearchParams, parsePermission, randomStr } from "../../commonModule";
import { LoadingSpinner } from "../common/commonParts";
import SnackMsg from "../common/SnackMsg";
import { CntbkLinksTab } from "./CntbkMake";
import CntbkUsersDispatcher from "./CntbkUsersDispatcher";

const useStyles = makeStyles({
  accessTokenMain: {
    margin: '0 auto',
    width: 'fit-content',
    '& .no': {
      width: "2rem", marginRight: 16
    },
    '& .name': {
      width: '8rem', marginRight: 16
    },
    '& .mail': {
      width: '16rem', marginRight: 16, marginLeft: 48
    },
    '& .token': {
      width: '4rem', marginRight: 16
    },
    '& .button': {
      width: 100,
    },
    '& .mailButton': {
      marginRight: 16
    },
    '& .header': {
      zIndex: "100",
      display: 'inline-flex', alignItems: 'center',
      position: 'sticky', top: '80px',
      marginBottom: 16, padding: '16px 0 4px 0',
      backgroundColor: 'white',  
      borderBottom: `1px ${teal[500]} solid`,
      '& .no': {
        textAlign: 'center'
      },
      '& .button': {
        textAlign: 'center'
      },
    },
    '& .body': {
      marginBotton: 16,
      '& .no': {
        paddingTop: 12, textAlign: 'right'
      },
      '& .name': {
        paddingTop: 12
      },
      '& .token': {
        textAlign: 'center', paddingTop: 12
      },
      '& .mail,.button': {
        height: 38
      },
    }
  }
})

const UpdateMailButton = (props) => {
  const {userDtList, changeMail, setChangeMail, mailAddress, setCheckMsg, mailErr, setSnack, setOriginMail, token, originUsers, setOriginUsers} = props;
  const handleClick = async() => {
    for(const userDt of userDtList){
      const prms = {"a": "sendUserWithEtc", ...userDt, "pmail": mailAddress, "faptoken": token};
      await axios.post(endPoint(), makeUrlSearchParams(prms)).then(res => {
        console.log(res)
        setSnack({...{msg: '書き込み完了しました。', id: new Date().getTime()}});
      })
      const origin_users = originUsers;
      const appropriate_index = originUsers.findIndex(uDt => uDt.uid === userDt.uid);
      origin_users[appropriate_index]["pmail"] = mailAddress;
      origin_users[appropriate_index]["faptoken"] = token;
      setOriginUsers([...origin_users]);
    }
    setCheckMsg("updateMail");
    setChangeMail(false);
    setOriginMail(mailAddress);
  }

  const disabled = !(changeMail && !mailErr)
  return(
    <Button
      className="mailButton button"
      variant='contained'
      disabled={disabled}
      color="primary"
      onClick={handleClick}
    >
      更新
    </Button>
  )
}

const MakeTokenButton = (props) => {
  const {
    userDtList, checkFap, setCheckFap,check, setCheck, changeMail, 
    mailAddress, setCheckMsg, setSnack, setToken, originUsers, setOriginUsers
  } = props;
  const handleClick = async() => {
    const token = randomStr(8);
    for(const userDt of userDtList){
      const sendUserWithEtc_prms = {"a": "sendUserWithEtc", ...userDt, "pmail": mailAddress, "faptoken": token}
      await axios.post(endPoint(), makeUrlSearchParams(sendUserWithEtc_prms)).then(res => {
        console.log(res)
        setSnack({...{msg: 'アクセスキー生成しました。', id: new Date().getTime()}});
      })
      const origin_users = originUsers;
      const appropriate_index = originUsers.findIndex(uDt => uDt.uid === userDt.uid);
      origin_users[appropriate_index]["pmail"] = mailAddress;
      origin_users[appropriate_index]["faptoken"] = token;
      setOriginUsers([...origin_users]);
    }
    const sendFapTokenMail_prms = {
      "a": "sendFapTokenMail",
      "pname": userDtList[0].pname, 
      "pmail": mailAddress,
      "faptoken": token,
      "mode": "new",
      "hname": userDtList[0].hname,
      "bname": userDtList[0].bname
    }
    await axios.post(endPoint(), makeUrlSearchParams(sendFapTokenMail_prms)).then(res => {
      setSnack({...{msg: 'アクセスキー送信しました。', id: new Date().getTime()}});
      console.log(res)
    })
    setCheck(false);
    setCheckFap(true);
    setCheckMsg(null);
    setToken(token);
  }
  const disabled = !changeMail && mailAddress ? false :true;

  if(check){
    return(
      <Button
        className="button"
        disabled={disabled}
        variant='contained'
        style={{backgroundColor: red[700], color: 'white'}}
        onClick={handleClick}
      >
        {checkFap ?"更新実行" :"送信実行"}
      </Button>
    )
  }else{
    return(
      <Button
        className="button"
        disabled={disabled}
        variant='contained'
        color="primary"
        onClick={() => {setCheck(true); setCheckMsg("makeToken")}}
      >
        {checkFap ?"更新" :"送信"}
      </Button>
    )
  }
}

const MailAddressTextField = (props) => {
  const {setChangeMail, mailAddress, setMailAddress, originMail, mailErr, setMailErr, setCheckMsg} = props;

  const handleChange = (e) => {
    setMailAddress(e.target.value);
    if(e.target.value === originMail){
      setCheckMsg(null);
      setChangeMail(false);
      return;
    }
    if(e.target.value !== originMail) {
      setCheckMsg("canselMail");
      setChangeMail(true);
    }
    const check = isMailAddress(e.target.value);
    if(!check || e.target.value===""){
      setMailErr(true);
    }else{
      setMailErr(false);
    }
  }

  return(
    <FormLabel>
      <Input
        className="mail"
        error={mailErr}
        value={mailAddress ?mailAddress :""}
        onChange={handleChange}
      />
      <FormHelperText style={{color: 'red', marginLeft: 48}}>{mailErr ?"メールアドレスが不正です" :null}</FormHelperText>
    </FormLabel>
  )
}

const MailCanselButton = (props) => {
  const {originMail, setMailAddress, setMailErr, setChangeMail, setCheckMsg} = props;
  const handleClick = () => {
    setMailAddress(originMail);
    setMailErr(false);
    setChangeMail(false);
    setCheckMsg(null);
  }
  return(
    <Button
      style={{padding: '3px 8px', fontSize: '0.75rem'}}
      color="default"
      variant='contained'
      onClick={handleClick}
    >
      キャンセル
    </Button>
  )
}

const BrosOneRow = ({userDtList, brosIndex, setSnack, originUsers, setOriginUsers, permission}) => {
  const pname = userDtList.reduce((name, userDt) => {
    if(!name) return userDt.pname;
    return name === userDt.pname ?name :"親氏名エラー";
  }, null);
  const name_nodes = userDtList.map((userDt, i) => <div key={i} style={{marginBottom: 4}}>{userDt.name}</div>);
  const mail = userDtList.reduce((mailAddress, userDt) => {
    if(!mailAddress) return userDt.pmail;
    return mailAddress === userDt.pmail ?mailAddress :"メールアドレスが違うため再登録";
  }, null);
  const token_init = userDtList.reduce((tokenInit, userDt) => {
    if(!tokenInit) return userDt.faptoken;
    return tokenInit === userDt.faptoken ?tokenInit :false;
  }, "");
  const check_faptoken = userDtList.every(userDt => userDt.faptoken ?true :false);
  const [changeMail, setChangeMail] = useState(false);
  const [mailAddress, setMailAddress] = useState(mail ==="" ?null :mail);
  const [token, setToken] = useState(token_init);
  const [checkFap, setCheckFap] = useState(check_faptoken);
  const [mailErr, setMailErr] = useState(false);
  const [check, setCheck] = useState(false);
  const [checkMsg, setCheckMsg] = useState(null);
  const [originMail, setOriginMail] = useState(mail);

  const mail_prms = {setChangeMail, mailAddress, setMailAddress, originMail, mailErr, setMailErr, setCheckMsg};
  const updatemail_prms = {userDtList, changeMail, setChangeMail, mailAddress, setCheckMsg, mailErr, setSnack, setOriginMail, token, originUsers, setOriginUsers};
  const faptoken_prms = {userDtList, checkFap, setCheckFap, check, setCheck, changeMail, mailAddress, setCheckMsg, setSnack, setToken, originUsers, setOriginUsers};
  const mailcansel_prms = {originMail, setMailAddress, setMailErr, setChangeMail, setCheckMsg}
  return(
    <div className="body">
      <div style={{display: 'flex'}}>
        <div className="no">{brosIndex+1}</div>
        <div className="name">{pname}</div>
        <div className="name">{name_nodes}</div>
        <MailAddressTextField {...mail_prms}/>
        <div className="token">{checkFap ?"済" :"未"}</div>
        <UpdateMailButton {...updatemail_prms}/>
        <div style={{width: 'fit-content'}}>
          <MakeTokenButton {...faptoken_prms}/>
          {permission===100 ?<div style={{width: 'fit-content', margin: '0 auto', marginTop: 4}}>{token}</div> :null}
        </div>
      </div>
      <div style={{color: red[700], paddingTop: 8, margin: '0 0 40px 3rem'}}>
        {
          checkMsg==="makeToken" ?"更新するとご家族向け連絡帳アプリのアクセス設定が変更されます。よろしいですか？" :
          checkMsg==="canselMail" ?"メールアドレスを変更するとアクセスキーの変更も必要です。" :
          checkMsg==="updateMail" ?"メールアドレスが更新されました。アクセスキーの更新をお強くお勧めします。" :null
        }
        {checkMsg==="canselMail" ?<MailCanselButton {...mailcansel_prms}/> :null}
      </div>
    </div>
  )
}

const MakeAccessTokenMain = ({users, setSnack, originUsers, setOriginUsers, permission}) => {
  const classes = useStyles();
  const list_by_bros = users.map(userDt => getFirstBros(userDt.uid, users) ?getBrothers(userDt.uid, users, true) :[userDt]);
  const bros_dtlist = [...new Set(list_by_bros.map(JSON.stringify))].map(JSON.parse).filter(x => x.length!==0);
  const rows = bros_dtlist.map((userDtList, index) => {
    const brosOneRow_prms = {userDtList, brosIndex: index, setSnack, originUsers, setOriginUsers, permission};
    return <BrosOneRow key={index} {...brosOneRow_prms} /> 
  })

  return(
    <div className={classes.accessTokenMain}>
      <div className="header">
        <div className="no">No</div>
        <div className="name">保護者名</div>
        <div className="name">利用者名</div>
        <div className="mail">メールアドレス</div>
        <div className="token">トークン<br/>設定済み</div>
        <div className="mailButton button">メール<br/>アドレス</div>
        <div className="button">アクセス<br/>キー</div>
      </div>
      <div>{rows}</div>
    </div>
  )
}

const MakeAccessToken = () => {
  const allState = useSelector(state => state);
  const loadingStatus = getLodingStatus(allState);
  const {users, service, classroom, account} = allState;
  const [snack, setSnack] = useState({});
  const [originUsers, setOriginUsers] = useState(users);
  const permission = parsePermission(account)[0][0];

  users.sort((a, b) => (parseInt(a.sindex) - parseInt(b.sindex)));
  const filtered_users = getFilteredUsers(users, service, classroom);
  if (loadingStatus.loaded){
    const makeAccessTokenMain_prms = {users: filtered_users, setSnack, originUsers, setOriginUsers, permission};
    return(
      <>
      <CntbkLinksTab />
      <div style={{margin: '84px 64px'}}>
        <MakeAccessTokenMain {...makeAccessTokenMain_prms}/>
      </div>
      <SnackMsg {...snack}/>
      <CntbkUsersDispatcher originUsers={originUsers} />
      </>
    )
  }else{
    return (
      <>
      <CntbkLinksTab />
      <LoadingSpinner/>
      </>
    )
  }
}
export default MakeAccessToken